import { type FC, type ReactNode } from "react"

import { cn } from "../utilities/tailwind"

type Props = {
	tooltip: string
	inline?: boolean
	className?: string
	children?: ReactNode
}
const Tooltip: FC<Props> = ({ tooltip, inline = false, className, children }) => (
	<div
		className={cn("cursor-default", inline && "inline", className)}
		data-tooltip-id="tooltip"
		data-tooltip-content={tooltip}
	>
		{children}
	</div>
)

export default Tooltip
